import * as Popover from '@radix-ui/react-popover';

import { cn, POPOVER_MOTION } from '../../../shared/lib/cn';
import { NotificationsIcon } from '../../../shared/ui/icons';
import { ShortcutTooltip } from '../../../shared/ui/tooltip';
import {
  NotificationDigestBody,
  NotificationDigestHeader,
  type TNotificationDigestState,
} from '../../../features/notification-feed';
import { RAIL_ITEM, SHELL_CHORDS } from './nav';
import { RailBadge } from './rail-badge';

// A panel over the current screen, not a page: what needs you is read without leaving the work.
export const NotificationsBell = ({
  state,
  timeZone,
  open,
  onOpenChange,
  collapsed,
}: {
  state: TNotificationDigestState;
  timeZone?: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  collapsed: boolean;
}) => {
  const close = () => onOpenChange(false);
  const unread = state.digest.data?.unread ?? 0;
  const label =
    unread > 0 ? `Notifications, ${unread.toLocaleString('en-US')} unread` : 'Notifications';

  return (
    <Popover.Root open={open} onOpenChange={onOpenChange}>
      <ShortcutTooltip off={!collapsed} label={label} keys={SHELL_CHORDS.notifications.keys}>
        <Popover.Trigger aria-label={label} className={RAIL_ITEM}>
          <NotificationsIcon size="lg" />
          {!collapsed && <span className="truncate">Notifications</span>}
          {unread > 0 && <RailBadge count={unread} tone="motion" collapsed={collapsed} />}
        </Popover.Trigger>
      </ShortcutTooltip>
      <Popover.Portal>
        <Popover.Content
          side="right"
          align="end"
          sideOffset={10}
          collisionPadding={12}
          className={cn(
            'flex max-h-bell-tall w-bell flex-col overflow-hidden rounded-panel border border-border-raised bg-surface-raised shadow-panel',
            'origin-(--radix-popover-content-transform-origin)',
            POPOVER_MOTION,
          )}
        >
          <NotificationDigestHeader state={state} onNavigate={close} />
          <div className="min-h-0 flex-1 overflow-y-auto">
            <NotificationDigestBody state={state} timeZone={timeZone} onNavigate={close} />
          </div>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
};
